
    import I18n from 'i18nObj';
    
      import 'translations/folder_tree';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('folder_tree');
  